<div class="container vw-100">
  <form [formGroup]="rawQuestionnaire" (ngSubmit)="onSubmit($event)">
    @for (question of rawQuestions; track question; let i = $index) {
      <div>
        @if (getQuestionVisibility(replaceSpace(question.questionID.toString() + '_' + question.question))) {
          <div
            class="card my-5 shadow"
            >
            @if (question.question) {
              <div class="card-header">
                <h6 class="card-title whitespace">
                  {{ question.question }}
                </h6>
              </div>
            }
            <div class="card-body">
              @if (getType(question.type) === 'video') {
                <app-video [videoSrc]="question.src" />
              }
              <!-- likert scale -->
              @if (getType(question.type) === 'likert') {
                <app-likert
                  [form]="rawQuestionnaire"
                  [controlName]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                  [labelLow]="question.minLabel"
                  [labelHigh]="question.maxLabel"
                  [rangeLow]="question.minRange"
                  [rangeHigh]="question.maxRange"
                ></app-likert>
              }
              <!-- multi-select -->
              @if (['radio', 'checkbox'].includes(getType(question.type))) {
                <div class="form-check">
                  @for (answer of question.answers; track answer) {
                    <div
                      class="form-check"
                      formGroupName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) + '_Group' }}"
                      >
                      <input
                        class="form-check-input"
                        [type]="getType(question.type)"
                        [id]="replaceSpace(question.questionID.toString() + '_' + answer)"
                        [name]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                        [value]="answer"
                        formControlName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) }}"
                (change)="
                  onMultiChange(replaceSpace(question.questionID.toString() + '_' + question.question), answer, $event)
                "
                        />
                      <label class="form-check-label" [for]="replaceSpace(question.questionID.toString() + '_' + answer)">
                        {{ answer }}
                      </label>
                    </div>
                  }
                </div>
              }
              <!-- dropdown -->
              <div formGroupName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) + '_Group' }}">
                @if (getType(question.type) === 'select') {
                  <select
                    [name]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    [id]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    formControlName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) }}"
                    class="form-control"
                    (change)="onSelectChange(replaceSpace(question.questionID.toString() + '_' + question.question), $event)"
                    >
                    <option value="" disabled selected>
                      {{ placeholderSelectAnswer }}
                    </option>
                    @for (answer of question.answers; track answer) {
                      <option [value]="answer">
                        {{ answer }}
                      </option>
                    }
                  </select>
                }
              </div>
              <!-- text -->
              <div formGroupName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) + '_Group' }}">
                @if (getType(question.type) === 'textarea') {
                  <input
                    type="textarea"
                    class="form-control"
                    [name]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    [id]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    formControlName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) }}"
                    [placeholder]="placeholderText"
                    />
                }
              </div>
              <!-- number input -->
              <div formGroupName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) + '_Group' }}">
                @if (getType(question.type) === 'number') {
                  <input
                    type="number"
                    class="form-control"
                    [name]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    [id]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                    [min]="question.minRange"
                    [max]="question.maxRange"
                    formControlName="{{ replaceSpace(question.questionID.toString() + '_' + question.question) }}"
                    [placeholder]="placeholderText"
                    />
                }
              </div>
              <!-- drag&drop -->
              @if (getType(question.type) === 'drag&drop' || getType(question.type) === 'drag&drop_selection') {
                <div>
                  <!--             <app-drag-n-drop
              (rankingChange)="
                onRankingChange(replaceSpace(question.questionID.toString() + '_' + question.question), $event)
              "
                  class="w-100 d-flex"
                  [answerOptions]="question.answers"
                  [useImages]="question.useImages"
                  [question]="replaceSpace(question.questionID.toString() + '_' + question.question)"
                ></app-drag-n-drop> -->
              </div>
            }
            <!-- slider -->
            <!-- TODO: might need to insert the raw HMTL instead of a component in order to easily change color of the slider if it has been touched -->
            @if (getType(question.type) === 'range') {
              <app-slider
                [range]="[question.minRange, question.maxRange]"
                [label]="[question.minLabel, question.maxLabel]"
            (valueChange)="
              onSliderChange(replaceSpace(question.questionID.toString() + '_' + question.question), $event)
            "
                [form]="rawQuestionnaire"
                [controlName]="replaceSpace(question.questionID.toString() + '_' + question.question)"
              ></app-slider>
            }
          </div>
        </div>
      }
    </div>
  }
  <div class="d-flex align-items-baseline">
    <button class="btn btn-primary mb-3" type="submit" [disabled]="!rawQuestionnaire.valid">
      {{ submitButtonLabel }}
    </button>
    @if (!rawQuestionnaire.valid) {
      <span class="ms-4 help-block">{{ validationHint }}</span>
    }
  </div>
</form>
</div>
